module.exports = __webpack_public_path__ + "6e7319587ff1137fd973eebe9bbbf21d.svg";